var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tabs" }, [
    _c(
      "ul",
      { staticClass: "tabs__nav", class: _vm.navClasses },
      _vm._l(_vm.tabList, function (tab, index) {
        return _c(
          "li",
          _vm._b(
            {
              key: index,
              staticClass: "tabs__tab",
              class: {
                "tabs__tab--active": _vm.activeTabIndex === index,
                "tabs__tab--disabled": tab.disabled,
              },
              on: {
                click: function ($event) {
                  return _vm.select(index)
                },
              },
            },
            "li",
            tab.dataAttrs,
            false
          ),
          [
            _c(
              "a",
              {
                staticClass: "tabs__link",
                class: {
                  "tabs__link--active": _vm.activeTabIndex === index,
                  "tabs__link--disabled": tab.disabled,
                },
                attrs: { href: "javascript:" },
              },
              [_vm._v(_vm._s(tab.title))]
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "tabs__content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }